module.exports = __webpack_public_path__ + "assets/images/agents.23dcd1a053fbab35969042b9c1e17b1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/getting-started/agents.png
// module id = 1064
// module chunks = 0